import { render } from "./ImageConfig.vue?vue&type=template&id=0ac9d54d&scoped=true&ts=true"
import script from "./ImageConfig.vue?vue&type=script&lang=ts"
export * from "./ImageConfig.vue?vue&type=script&lang=ts"

import "./ImageConfig.vue?vue&type=style&index=0&id=0ac9d54d&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac9d54d"]])

export default __exports__